export default __webpack_public_path__ + "static/media/smarthire.600f276d.png";